import React, { useEffect, useState } from "react";
import axios from "axios";
import { PRODUCT_IMAGES } from "@/data/products";
import ProductCatalogCard, { ProductCatalogGrid } from "@/components/site/ProductCatalogCard";

import { API } from "@/lib/api";
const STATIC_ITEMS = [
  // ————————— Sacolas de Algodão (main + applications reais) —————————
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-01",
    features: ["Algodão cru 160g/m²", "Silk Screen, Transfer Digital, DTF", "Pedido mínimo: 50 un."],
    src: PRODUCT_IMAGES.ecobag,
    link: "/produtos/ecobag-algodao",
  },
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-CT",
    features: ["Algodão cru 160g/m²", "Impressão frente e verso", "Alças reforçadas"],
    src: PRODUCT_IMAGES.ecobagCatalogo,
    link: "/produtos/ecobag-algodao",
  },
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-04",
    features: ["Algodão cru 200g/m²", "Acabamento reforçado", "Silk Screen, Transfer Digital, DTF"],
    src: PRODUCT_IMAGES.ecobagAlt,
    link: "/produtos/ecobag-algodao",
  },
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-RM",
    features: ["Transfer digital 20×30 cm", "Algodão cru 160g/m²", "Aplicação real"],
    src: "/legacy/sc-com-uma-empress-o-digital.png",
    link: "/produtos/ecobag-algodao",
  },
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-SW",
    features: ["Transfer digital 28×30 cm", "Algodão cru 160g/m²", "Aplicação real"],
    src: "/legacy/bolsa-ecol-gica-para-a-sustentabilidade-2026.png",
    link: "/produtos/ecobag-algodao",
  },
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-BT",
    features: ["Transfer digital 28×40 cm", "Algodão cru 160g/m²", "Aplicação real"],
    src: "/legacy/chatgpt-image-26_06_2026-07_43_56.png",
    link: "/produtos/ecobag-algodao",
  },
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-EC",
    features: ["Transfer digital 38×40 cm", "Algodão cru 160g/m²", "Aplicação real"],
    src: "/legacy/whatsapp-image-2026-06-24-at-17.07.46-2-.jpeg",
    link: "/produtos/ecobag-algodao",
  },
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-PP",
    features: ["Transfer digital 38×40 cm", "Algodão cru 160g/m²", "Aplicação real"],
    src: "/legacy/whatsapp-image-2026-06-24-at-17.07.40-1-.jpeg",
    link: "/produtos/ecobag-algodao",
  },
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-KA",
    features: ["Kit personalizado", "Aplicação em evento", "Algodão cru natural"],
    src: PRODUCT_IMAGES.ecobagKitA,
    link: "/produtos/ecobag-algodao",
  },
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-KB",
    features: ["Aplicação em ambiente real", "Silk Screen", "Alças reforçadas"],
    src: PRODUCT_IMAGES.ecobagKitB,
    link: "/produtos/ecobag-algodao",
  },
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-KC",
    features: ["Aplicação real", "Uso em evento", "Algodão cru premium"],
    src: PRODUCT_IMAGES.ecobagKitC,
    link: "/produtos/ecobag-algodao",
  },
  {
    name: "Sacola de Algodão",
    code: "MN-ECO-KD",
    features: ["Brinde executivo", "Personalização premium", "Acabamento cuidadoso"],
    src: PRODUCT_IMAGES.ecobagKitD,
    link: "/produtos/ecobag-algodao",
  },

  // ————————— Sacolas TNT (main + variações reais) —————————
  {
    name: "Sacola TNT",
    code: "MN-TNT-01",
    features: ["TNT 80g/m² ou 100g/m²", "Silk Screen, Transfer Digital, DTF", "Pedido mínimo: 100 un."],
    src: PRODUCT_IMAGES.tntNovoCapa,
    link: "/produtos/sacola-tnt",
  },
  {
    name: "Sacola TNT",
    code: "MN-TNT-SC",
    features: ["TNT 100g/m² preto", "Transfer Digital", "Aplicação real"],
    src: PRODUCT_IMAGES.tntNovo2,
    link: "/produtos/sacola-tnt",
  },
  {
    name: "Sacola TNT",
    code: "MN-TNT-AP",
    features: ["TNT 100g/m² branco", "Transfer Digital colorido", "Alças azul marinho"],
    src: PRODUCT_IMAGES.tntNovo3,
    link: "/produtos/sacola-tnt",
  },
  {
    name: "Sacola TNT",
    code: "MN-TNT-PD",
    features: ["TNT 100g/m² preto", "Transfer Digital colorido", "Alças pretas"],
    src: PRODUCT_IMAGES.tntNovo4,
    link: "/produtos/sacola-tnt",
  },
  {
    name: "Sacola TNT",
    code: "MN-TNT-BA",
    features: ["TNT 80g/m²", "Alça colorida", "Transfer Digital"],
    src: PRODUCT_IMAGES.tntBrancoAlca,
    link: "/produtos/sacola-tnt",
  },
  {
    name: "Sacola TNT",
    code: "MN-TNT-VD",
    features: ["TNT 80g/m² — verde", "Formato 33×40 cm", "Silk Screen"],
    src: PRODUCT_IMAGES.tntVerde,
    link: "/produtos/sacola-tnt",
  },
  {
    name: "Sacola TNT",
    code: "MN-TNT-RS",
    features: ["TNT 80g/m² — rosa", "Formato 33×40 cm", "Silk Screen"],
    src: PRODUCT_IMAGES.tntRosa,
    link: "/produtos/sacola-tnt",
  },
  {
    name: "Sacola TNT",
    code: "MN-TNT-BT",
    features: ["TNT 80g/m² branca", "Transfer Digital fotográfico", "Full-color"],
    src: PRODUCT_IMAGES.tntBrancoTransfer,
    link: "/produtos/sacola-tnt",
  },

  // ————————— Squeezes / Canecas —————————
  {
    name: "Squeeze de Alumínio",
    code: "MN-SQZ-01",
    features: ["Alumínio leve", "500 ml / 750 ml", "Gravação laser ou silk"],
    src: PRODUCT_IMAGES.squeeze,
    link: "/produtos/squeeze",
  },
  {
    name: "Caneca Personalizada",
    code: "MN-CAN-01",
    features: ["Cerâmica esmaltada branca", "Capacidade 325 ml", "Transfer Digital"],
    src: PRODUCT_IMAGES.canecaPersonalizada,
    link: "/produtos/caneca-personalizada",
  },

  // ————————— Toalhas (imagens reais corretas) —————————
  {
    name: "Toalha Social Slim 23×36",
    code: "MN-TLH-SS",
    features: ["Algodão 100%", "Formato slim 23×36 cm", "Silk Screen, Transfer Digital, DTF"],
    src: PRODUCT_IMAGES.socialSlimCapaCorreta,
    link: "/produtos/toalha-social-slim",
  },
  {
    name: "Toalha Fitness Slim 29×70",
    code: "MN-TLH-FS",
    features: ["Algodão 100%", "Slim 29×70 cm", "Silk Screen, Transfer Digital, DTF"],
    src: PRODUCT_IMAGES.fitnessSlimCapaCorreta,
    link: "/produtos/toalha-fitness-slim",
  },

  // ————————— Camiseta / Caderno / Chapéu —————————
  {
    name: "Camiseta de Algodão Gola Careca",
    code: "MN-CAM-GC",
    features: ["Algodão penteado 30.1", "Gola careca reforçada", "Silk Screen, Transfer Digital, DTF"],
    src: PRODUCT_IMAGES.camisetaCapa,
    link: "/produtos/camiseta-algodao-gola-careca",
  },
  {
    name: "Caderno Moleskine",
    code: "MN-CAD-MK",
    features: ["Capa dura colorida", "Elástico e marcador", "Miolo pautado 80 fls"],
    src: PRODUCT_IMAGES.cadernoCapa,
    link: "/produtos/caderno-moleskine",
  },
  {
    name: "Chapéu Estilo Panamá",
    code: "MN-CHP-PN",
    features: ["Acabamento que remete à palha natural", "Fita grosgrain preta", "Bordado personalizado"],
    src: PRODUCT_IMAGES.chapeuBege,
    link: "/produtos/chapeu-panama",
  },

  // ————————— Mochilas / Saquinho / Serviços —————————
  {
    name: "Mochila Corporativa",
    code: "MN-MCH-EX",
    features: ["Poliéster premium preto", "Notebook 15,6\"", "Alças ergonômicas"],
    src: PRODUCT_IMAGES.mochilaCorporativa,
    link: "/produtos/mochila-corporativa",
  },
  {
    name: "Sacola Tipo Mochila Ecológica",
    code: "MN-MCH-EC",
    features: ["Algodão cru bege claro", "Alças em cordão mochila", "Opção microfibra"],
    src: PRODUCT_IMAGES.mochilaEcoAlgodao,
    link: "/produtos/sacola-mochila-ecologica",
  },
  {
    name: "Saquinho em Algodão Cru",
    code: "MN-SAQ-01",
    features: ["Algodão cru 100% natural", "Fechamento em cordão", "Silk Screen, Transfer Digital, DTF"],
    src: PRODUCT_IMAGES.saquinhoAlgodao,
    link: "/produtos/saquinho-algodao-cru",
  },
  {
    name: "DTF Têxtil Personalizado",
    code: "MN-DTF-01",
    features: ["Impressão têxtil DTF", "Full color CMYK + branco", "Alta durabilidade"],
    src: PRODUCT_IMAGES.dtfTextil,
    link: "/produtos/dtf-textil",
  },
  {
    name: "Transfer Digital Personalizado",
    code: "MN-TRD-01",
    features: ["Transfer termocolante", "Cores vibrantes CMYK", "Acabamento profissional"],
    src: PRODUCT_IMAGES.transferDigital,
    link: "/produtos/transfer-digital",
  },
];

export const Gallery = () => {
  const [uploaded, setUploaded] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/gallery`)
      .then((r) => setUploaded(r.data || []))
      .catch(() => setUploaded([]));
  }, []);

  const items = [
    ...uploaded.map((p) => ({
      key: p.id,
      name: p.title || "Aplicação personalizada",
      code: p.category ? `MN-${p.category.toUpperCase().slice(0, 6)}` : "MN-GAL",
      features: ["Foto enviada pelo cliente", "Aplicação real"],
      src: `${API}/gallery/file/${p.id}`,
      link: "/catalogo",
    })),
    ...STATIC_ITEMS.map((it, i) => ({ ...it, key: `s-${i}` })),
  ];

  return (
    <section id="galeria" data-testid="gallery-section" className="mn-section bg-white">
      <div className="mn-container">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <span className="mn-eyebrow">Portfólio</span>
            <h2 className="mn-h-display text-[2.25rem] sm:text-[2.75rem] lg:text-[3.25rem] mt-4">
              Catálogo de <span style={{ color: "var(--mn-gold)" }}>aplicações reais.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[var(--mn-dark)] leading-relaxed">
              Trabalhos entregues para clientes corporativos em todo o Brasil. Cada peça mostra possibilidades reais de personalização para a sua marca.
            </p>
          </div>
        </div>

        <ProductCatalogGrid testId="gallery-grid">
          {items.map((it) => (
            <ProductCatalogCard
              key={it.key}
              name={it.name}
              code={it.code}
              image={it.src}
              features={it.features}
              link={it.link}
              testIdSlug={it.key}
            />
          ))}
        </ProductCatalogGrid>
      </div>
    </section>
  );
};

export default Gallery;
